import {Expressions} from '@packages/systems/wfdl';
import type {Expression} from '@packages/systems/wfdl-ast';
import {isOptimizationTreatmentElement} from '@packages/utilities/platform';

export function getClosestOptimizationTreatment(
  elementId: string,
  tree: Expression
) {
  return Expressions.closestElement(
    tree,
    elementId,
    isOptimizationTreatmentElement
  );
}
